// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2EBh9","productName":"Table_productName__37ltb"};